// Types
//import { Components, Types } from "../../types";
import styled, {css} from 'styled-components';
import { Helpers } from '../../utils';

const SwatchesSelect = ({ options, onSelect: handleSelect }: any) => {
    
    return (
        <SwatchesSelectWrapper>
            <div className="select__options">
                {options.map( (option: any, index: number) => 
                    <SwatchOption key={index} {...option} onSelect={handleSelect} />)
                }
            </div>
        </SwatchesSelectWrapper>
    )

}

const SwatchOption = ({label, value, selected, available, onSelect}: any) => {
    //  title={!available ? `Pre zvolenú kombináciu atribútov nie je možnosť ${label.toLowerCase()} dostupná.`: undefined}
    return (
        <button disabled={!available} className={`swatch-option${ selected ? ' active' : '' }`} onClick={() => (! selected && available) && onSelect( value )}>
            <span className="swatch-option__label">{label}</span>
        </button>
    )

}

const SwatchesSelectWrapper = styled.div(
({ theme: { general, components: {productAttributes: style} } }) => css`

    display: flex;
    align-items: center;
    position: relative;
    
    .select__options {
        display: flex;
        flex-flow: row wrap;
        gap: 1em;
        width: 100%;
    }

    .swatch-option {

        background: transparent;

        width: fit-content; 
        flex: 0 0 auto;
        ${Helpers.clamp('padding-block', 0.5, 0.625, 2.5)} ;
        ${Helpers.clamp('padding-inline', 1, 1.25, 2.5)};
        border: 2px #333 solid;

        display: flex;
        align-items: center;
        justify-self: unset;
        color: #1d1d1b;
        
        cursor: pointer;
        user-select: none;

        transition: all ${general.transition.duration} ${general.transition.timingFunction};

        outline: none;

        &:disabled {
            opacity: .25;
            cursor: not-allowed;
        }
        
        &.active {
            background-color: #1d1d1b;
            color: #fff;
        }

        // TODO: Mixin
        &:not(:hover):focus-within {
            box-shadow: 0 0 0 .25em rgba(0, 0, 0, .15) !important;
        }

        &:hover {
            transform: translateY(-0.25em);
        }

        @media (-moz-touch-enabled: 1), (hover: none), (pointer: coarse) {
            &:hover {
            transform: translateY(0);
            }
            &:focus-within {
                box-shadow: unset !important;
            }
            &:active {
                box-shadow: 0 0 0 .25em rgba(0, 0, 0, .15) !important;
            }
        }
    
    }
`);

export default SwatchesSelect;